// 导入api接口模块
import home from './home'
// 导入购物车商品接口
import trolley from './shopping-troelly'

// 获取当前环境变量 true => 生产环境 false => 开发环境
const BASEURL = (process.env.NODE_ENV === 'production') ? 'https://shop.zwgongxiang.com/appapi' : '/api'

export const api = {
  // 登录模块
  ...home(BASEURL),
  ...trolley(BASEURL),
  vCode: `${BASEURL}/app/getCode`,
  login: `${BASEURL}/app/login`,
  // 图片上传
  upload: `${BASEURL}/file/upload`,
  // 店铺模块
  getShopIndex: `${BASEURL}/shop/getIndex`, // 查询店铺首页
  getShopClassify: `${BASEURL}/shop/getShopClassify`, // 查询店铺分类
  getShopProducts: `${BASEURL}/shop/getShopProducts`, // 查询店铺商品
  getShopBanner: `${BASEURL}/shop/getShopBanner`, // 获取店铺banner
  getSeckill: `${BASEURL}/seckill/getIndex`, // 秒杀专区
  getDiscount: `${BASEURL}/discount/getIndex`, // 折扣专区
  getWork: `${BASEURL}/work/getIndex`, // 拼团专区
  // 我的评价模块
  getEvaluateList: `${BASEURL}/comment/getAll`, // 查询我的评价列表
  likes: `${BASEURL}/comment/like`, // 点赞
  getEvaluateData: `${BASEURL}/comment/getById`, // 查询评价内容
  // 首页模块
  getSearchProducts: `${BASEURL}/app/getSearchProducts`, // 搜索商品
  getShops: `${BASEURL}/shop/getShops`, // 搜索店铺
  // 分类模块
  getClaasifyProducts: `${BASEURL}/classify/getClaasifyProducts`, // 查询分类商品
  // 订单模块
  getOrderList: `${BASEURL}/order/getAll`, // 查询订单列表
  getOrderDetail: `${BASEURL}/order/getById`, // 查询订单详情
  cancelOrder: `${BASEURL}/order/cancel`, // 取消订单
  confirm: `${BASEURL}/order/confirm`, // 确认收货
  deleteOrder: `${BASEURL}/order/delete`, // 删除订单
  getExpressSelect: `${BASEURL}/order/getExpressSelect`, // 选择物流公司查询
  returnExpress: `${BASEURL}/order/returnExpress`, // 填写退货物流单
  addComment: `${BASEURL}/order/addComment`, // 添加评论
  addToComment: `${BASEURL}/order/addToComment`, // 追加评论
  getDilevery: `${BASEURL}/order/getDilevery`, // 查询物流信息
  buyAgain: `${BASEURL}/cart/buyAgain`, // 再次购买
  getShare: `${BASEURL}work/getShare`, // 邀请拼团
  getInvite: `${BASEURL}/work/getInvite`, // 邀请拼团信息
  // 收货地址模块
  addressList: `${BASEURL}/receive/getAll`, // 收货地址管理查询
  selectAddress: `${BASEURL}/receive/getSelect`, // 选择收货地址查询
  changeAddress: `${BASEURL}/receive/getById`, // 修改收货地址查询
  delAddress: `${BASEURL}/receive/delete`, // 删除收货地址
  updateAddress: `${BASEURL}/receive/update`, // 修改收货地址
  newAddress: `${BASEURL}/receive/save`, // 添加收货地址
  // 优惠券模块
  getCoupons: `${BASEURL}/coupon/getCoupons`, // 优惠券列表
  getCouponList: `${BASEURL}/coupon/getCouponList`, // 优惠券列表不带分页
  takeCoupon: `${BASEURL}/coupon/takeCoupon`, // 领取优惠券
  getCouponProducts: `${BASEURL}/coupon/getCouponProducts`, // 优惠券商品列表查询
  // 个人信息模块
  getUser: `${BASEURL}/user/getUser`, // 个人系信息查询
  updatePassword: `${BASEURL}/user/updatePassword`, // 修改密码
  relievePhone: `${BASEURL}/user/relievePhone`, // 解除绑定手机号
  updatePhone: `${BASEURL}/user/updatePhone`, // 更换绑定手机号
  update: `${BASEURL}/user/update`, // 修改个人信息
  checkUser: `${BASEURL}/user/checkUser`, // 身份验证
  getSelfProblems: `${BASEURL}/user/getSelfProblems`, // 我的提问
  getSelfAnswers: `${BASEURL}/user/getSelfAnswers`, // 我的回答
  delProblem: `${BASEURL}/seckill/deleteProblem`, // 批量删除我的提问
  delAnswer: `${BASEURL}/seckill/deleteAnswer`, // 批量删除我的回答
  getFootprint: `${BASEURL}/footprint/getAll`, // 我的足迹
  delFootprint: `${BASEURL}/footprint/delete`, // 删除足迹
  getAllShop: `${BASEURL}/collect/getAllShop`, // 收藏店铺查询
  getAllProduct: `${BASEURL}/collect/getAllProduct`, // 收藏商品查询
  unfavorite: `${BASEURL}/collect/cancel`, // 取消收藏
  // 商品模块
  getProDetail: `${BASEURL}/product/getById`, // 商品详情
  getProOption: `${BASEURL}/product/getProducts`, // 选择商品配置信息
  addCart: `${BASEURL}/cart/addCart`, // 加入购物车
  getEvaluate: `${BASEURL}/comment/getProductAll`, // 商品评价
  collect: `${BASEURL}/collect/collect`, // 收藏商品/店铺
  getProblems: `${BASEURL}/seckill/getProblems`, // 查询商品问答
  addProblem: `${BASEURL}/seckill/addProblem`, // 提问
  addAnswer: `${BASEURL}/seckill/addAnswer`, // 回答
  // 结算模块
  getSettlement: `${BASEURL}/order/getSettlement`, // 加入购物车
  // 画布模块
  fileUpload: BASEURL + '/file/upload', // 文件上传
  getClassify: BASEURL + '/canvas/getClassify', // 查询分类层级
  getProducts: BASEURL + '/canvas/getProducts', // 选择商品查询
  getCanvas: BASEURL + '/canvas/getCanvas', // 读取画布
  // 支付模块
  getOrderCoupons: `${BASEURL}/order/getOrderCoupons`, // 结算列表优惠券
  orderSubmit: `${BASEURL}/order/submit`, // 结算列表优惠券
  pay: `${BASEURL}/order/pay`, // 支付
  getPayCode: `${BASEURL}/order/getUrl`, // 根据订单id获取收款码
  checkPay: `${BASEURL}/order/checkPay`, // 监听支付
  getWorkSettlement: `${BASEURL}/work/getSettlement`, // 拼团单结算查询
  // 售后
  submit: `${BASEURL}/after/submit`, // 申请售后
  getReasonSelect: `${BASEURL}/after/getReasonSelect`, // 选择退款原因查询
  returnRefund: `${BASEURL}/after/returnRefund`, // 撤销退款
  returnGoods: `${BASEURL}/after/returnGoods`, // 撤销退货
  getPay: BASEURL + '/order/pay', // 支付处理业务
  getAfterSaleList: `${BASEURL}/after/getAll`, // 获取售后列表
  getAfterSaleDetail: `${BASEURL}/after/getById`, // 获取售后订单详情
  platform: `${BASEURL}/after/platform`, // 申请平台介入
  settled: `https://shop.zwgongxiang.com/settled-merchant/#/`, // 商家入驻地址
  // settled: `http://localhost:8081/#/`, // 商家入驻地址
  // 消息模块
  noticeGetAll: `${BASEURL}/notice/getAll`, // 消息列表
  noticeDetails: `${BASEURL}/notice/getById`, // 消息详情
  getGongGaoAll: `${BASEURL}/notice/getGongGaoAll` // 公告列表
}
export default api



// WEBPACK FOOTER //
// ./src/api/index.js